// extracted by mini-css-extract-plugin
export default {"links":"A0zM3o","link":"E3TT39"};